import { RoleTypes } from "../../../../../auth/authorizationTypes";

/**
 * Roles granted full access to Standards management regardless of org-unit
 * scoping (e.g. `storefront-manage`). Kept in sync across every
 * `hasRoleIn(...)` check that gates Standards features so the admin role set
 * can't silently drift between call sites.
 */
export const standardsManagementAdminRoles: RoleTypes[] = [
  "CustomerAdmin",
  "ShiAdmin",
  "GlobalAdmin",
  "ProcurementAdmin",
];
